import React from 'react'
import { Spinner, Text } from '@shopify/polaris'
import { Link } from 'react-router-dom'
import NoDataMessage from 'components/NoDataMessage/NoDataMessage'
import { ReactComponent as FinanceImg } from 'img/illustrations/general/finance-img.svg'
import { formatDate } from 'utils/dates'
import _ from 'lodash'

const NewsSection = ({ news, fetchingNews, t, navigate }) => {
	return (
		<div
			style={{
				background: '#fff',
				borderRadius: 8,
				width: '100%',
				border: '1px solid rgba(227, 227, 227, 1)'
			}}
		>
			<div style={{
				background: '#fff',
				borderTopLeftRadius: 8,
				borderTopRightRadius: 8,
				borderBottom: '1px solid rgba(227, 227, 227, 1)',
				marginBottom: 16,
				padding: '0 24px',
				height: 54,
				display: 'flex',
				alignItems: 'center',
				width: '100%'
			}}>
				<div style={{
					width: '100%',
					display: 'flex',
					flexDirection: 'row',
					alignItems: 'center',
					justifyContent: 'space-between',
				}}>
					<h2 style={{ fontWeight: 'bold', fontSize: 18 }}>
						{t("home.title.news")}
					</h2>
					<button
						style={{
							background: '#fff',
							borderColor: 'transparent',
							color: '#267FD7',
							cursor: 'pointer',
							fontSize: 14,
							fontWeight: 400,
						}}
						onClick={() => navigate("/home/news")}
					>
						{t("home.viewAll")}
					</button>
				</div>
			</div>
			{fetchingNews && <Spinner />}
			{!fetchingNews && !_.isEmpty(news) && (
				<>
					{news.map((newsItem) => (
						<div key={newsItem.id} style={{ padding: '16px 24px', borderBottom: '1px solid rgba(227, 227, 227, 1)' }}>
							<div style={{ display: 'flex', flexWrap: 'nowrap' }}>
								<div>
									{newsItem?.imageSrc && (
										<img
											alt='news'
											width='180px'
											height='100%'
											style={{
												borderRadius: "8px",
												objectFit: "cover",
												objectPosition: "center",
											}}
											src={newsItem?.imageSrc || ""}
										/>
									)}
								</div>
								<div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
									<div style={{
										display: 'flex',
										flexDirection: 'column',
										width: '100%',
									}}>
										<Text variant='bodyMd' color='subdued'>
											<span style={{ fontSize: 14, color: 'rgba(112, 112, 112, 1)', fontWeight: 400 }}>
												{formatDate(newsItem.date)}
											</span>
										</Text>
										<h2 style={{ fontSize: 16, fontWeight: '600', lineHeight: '1.2', margin: '10px 0' }}>
											{newsItem.title}
										</h2>
										<Text>
											<span
												dangerouslySetInnerHTML={{
													__html: newsItem.description,
												}}
												style={{ fontSize: 14, fontWeight: 400, lineHeight: '18px' }}
											/>
										</Text>
										<Link
											className='Polaris-Link'
											to={`/home/news/${newsItem.id}`}
											style={{ textDecoration: "none", marginTop: 10 }}
										>
											{t("home.readMore")}
										</Link>
									</div>
								</div>
							</div>
						</div>
					))}
				</>
			)}
			{!fetchingNews && _.isEmpty(news) && (
				<div>
					<NoDataMessage
						title={t("home.noArticlesYet")}
						Image={FinanceImg}
						style={{ height: "auto" }}
					/>
				</div>
			)}
		</div>
	)
}

export default NewsSection

